export const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_CLIENT_ID!, 
      authority:process.env.REACT_APP_MSAL_AUTHORITY!, 
      redirectUri: window.location.origin, 
      knownAuthorities: [process.env.REACT_APP_KNOWN_AUTHORITY!]
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: true, 
    },    
  };
  
  export const loginRequest = {
   scopes: [process.env.REACT_APP_SCOPE!] // Scopes you need for access
  };
  
  export const apiRequest = {
    scopes: [process.env.REACT_APP_SCOPE!], 
  };